export const STAGE = process.env.STAGE ?? 'local'
export const IS_PROD = STAGE === 'prod'

const API_BASE_URLS = {
  local: 'http://0.0.0.0:3000',
  // local: 'https://e6eb5ed681c0.ngrok.app',
  // local: 'https://api.radom.com',
  dev: 'https://api.dev.radom.com',
  test: 'https://api.test.radom.com',
  prod: 'https://api.radom.com'
}

export const API_BASE_URL = API_BASE_URLS[STAGE]

export enum RADOM_COLORS {
  BLACK = '#282828',
  BLUE = 'rgb(7, 7, 40)',
  NEW_BLUE = '#3464E6',
  BLUE_ALT = '#0E259C',
  BLUE_MED = '#0F1D4B',
  PURPLE = '#9F76EA',
  ORANGE = '#FF6648',
  ORANGE_MED = '#FF8972',
  ORANGE_LIGHT = '#FFDBD4',
  ORANGE_LIGHTEST = '#FFF2EFAA',
  SUCCESS = '#36AF67',
  SUCCESS_LIGHT = '#d8f3e3',
  WARNING = '#F79009',
  WARNING_LIGHT = '#FEF0C7',
  INFO = '#5490EC',
  INFO_LIGHT = '#d1e1fa',
  ERROR = '#FF5252',
  ERROR_LIGHT = '#ffdfdf',
  GRAY_DARKEST = '#636576',
  GRAY_DARKER = '#9B9EB1',
  GRAY_DARK = '#E2E4EF',
  GRAY_MED = '#EFF0F8',
  GRAY_LIGHTEST = '#F8F8FB',
  INPUT_PLACEHOLDER = '#9ba3af',
  NICE_GREEN = '#4bb69c',
  NICE_BLUE = '#07053f',
  NEW_GRAY_1 = '#33324F',
  DARK_BLUE = '#07053f',
  BLUE4 = '#3464e6',
  BLUE5 = '#618afa',
  BLUE7 = '#e7ecff',
  GRAY4 = '#8D91AC',
  GRAY8 = '#E3E5F0',
  GRAY9 = '#eff0f8',
  RED50 = '#ffecf0',
  RED300 = '#ffa9b9',
  RED900 = '#dc082e',
  INPUT_DEFAULT = 'rgb(239 240 248 / 60%)'
}

export enum WINDOW_SIZE {
  MOBILE_SMALL = '320px',
  MOBILE_MEDIUM = '375px',
  MOBILE_LARGE = '425px',
  TABLET = '768px',
  LAPTOP = '1024px',
  LAPTOP_LARGE = '1440px',
  DESKTOP = '2560px'
}

export const SecondsToPaymentPeriod = (seconds: number): string => {
  const intervals = {
    1: 'Second',
    60: 'Minute',
    [60 * 60]: 'Hour',
    [60 * 60 * 24]: 'Day',
    [60 * 60 * 24 * 7]: 'Week',
    [60 * 60 * 24 * 30]: 'Month',
    [60 * 60 * 24 * 30 * 3]: 'Quarter',
    [60 * 60 * 24 * 30 * 6]: 'Six Months',
    [60 * 60 * 24 * 365]: 'Year'
  }

  if (intervals[seconds]) {
    return intervals[seconds]
  }

  if (seconds > 60 * 60 * 24 * 365) {
    const years = (seconds / (60 * 60 * 24 * 365)).toFixed(1)
    return `${years} Years`
  }
  if (seconds > 60 * 60 * 24 * 30) {
    const months = (seconds / (60 * 60 * 24 * 30)).toFixed(1)
    return `${months} Months`
  }
  if (seconds > 60 * 60 * 24) {
    const days = (seconds / (60 * 60 * 24)).toFixed(1)
    return `${days} Days`
  }
  if (seconds > 60 * 60) {
    const hours = (seconds / (60 * 60)).toFixed(1)
    return `${hours} Hours`
  }
  if (seconds > 60) {
    const minutes = (seconds / 60).toFixed(1)
    return `${minutes} Minutes`
  }

  return `${seconds} Seconds`
}

export const formatSubscriptionDuration = (numSeconds: number): string => {
  if (SecondsToPaymentPeriod(numSeconds)) {
    return SecondsToPaymentPeriod(numSeconds)
  }

  return `${numSeconds} seconds`
}

const RADOM_CONTRACT_ADDRESSES = {
  31337: '0x749a0F73869eb0b0389F37B2Cee2b8DE5B358baB',
  5: '0x9D4B6432c290D4c393Bbe8fa30b72e240c008F17',
  80001: '0x987296974b23c050d6Eb2BE0CB2A60a1e9CeBa4e',
  4002: '0x819b60B377f99f1c1e8d40B53538b5Dbe1B4a37B',
  11155111: '0x8BBAaaE8225455ce62FCA83FF761fF4895bdD27B',
  1313161555: '0xc17C78B13f9594D974AF55921751B0919E4f377D',
  43113: '0xCc8401Fbca27934D4bFC762FEbb667ACdb976F88',
  534353: '0x3a909d378A6504287C03E0B19FdfB12f84c229e7',
  137: '0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028',
  56: '0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028',
  1: '0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028',
  1313161554: '0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028',
  250: '0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028',
  43114: '0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028',
  66: '0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028'
}

export const getRadomContractAddress = (chainId: number): string => {
  if (RADOM_CONTRACT_ADDRESSES[chainId]) {
    return RADOM_CONTRACT_ADDRESSES[chainId]
  }

  return RADOM_CONTRACT_ADDRESSES[31337]
}

export const EXPLORER_URLS: { [key: string]: string } = {
  RadomDevNet: 'http://localhost:9545',
  GoerliTestnet: 'https://goerli.etherscan.io',
  PolygonTestnet: 'https://mumbai.polygonscan.com',
  FantomTestnet: 'https://testnet.ftmscan.com',
  SepoliaTestnet: 'https://sepolia.etherscan.io',
  BitcoinTestnet: 'https://mempool.space/testnet',
  Bitcoin: 'https://mempool.space',
  AuroraTestnet: 'https://explorer.testnet.aurora.dev',
  Aurora: 'https://explorer.aurora.dev',
  Arbitrum: 'https://arbiscan.io',
  Ethereum: 'https://etherscan.io',
  Fantom: 'https://ftmscan.com',
  AvalancheTestnet: 'https://testnet.snowtrace.io',
  Avalanche: 'https://snowtrace.io',
  ScrollTestnet: 'https://blockscout.scroll.io',
  Polygon: 'https://polygonscan.com',
  BNB: 'https://bscscan.com',
  BNBTestnet: 'https://testnet.bscscan.com',
  PolkadotTestnet: 'https://westend.subscan.io',
  Polkadot: 'https://polkadot.subscan.io',
  TronTestnet: 'https://nile.tronscan.org/#',
  Tron: 'https://tronscan.org/#'
}


export const SANCTIONED_COUNTRIES = new Set([
  "Afghanistan",
  "Belarus",
  "Central African Republic",
  "Cuba",
  "Democratic Republic of the Congo",
  "Ethiopia",
  "Iran",
  "Iraq",
  "Lebanon",
  "Libya",
  "Mali",
  "Myanmar",
  "Nicaragua",
  "North Korea",
  "Russia",
  "Somalia",
  "South Sudan",
  "Sudan",
  "Syria",
  "Ukraine",
  "Venezuela",
  "Yemen",
])

export const ZERO_POPULATION_TERRITORIES = new Set([
  "Antarctica",
  "Baker Island",
  "Bouvet Island",
  "Heard Island and McDonald Islands",
  "Howland Island",
  "Jarvis Island",
  "Johnston Atoll",
  "Kingman Reef",
  "Palmyra Atoll",
  "Paracel Islands",
  "South Georgia",
])
